import { Service } from "../../types/service";
import { AnimatedNumber } from "../../components/cardItem/AnimatedNumber";
import {
  openAddModelData,
  openUpdateModelData,
  setNewPackageModelTrue,
} from "../../store/slices/modalSlice";
import { useDispatch } from "react-redux";
import { useCart } from "../../hooks/useCart";

interface PackageListProps {
  allServices: Service[];
  slug: string;
  mainCatName: string;
}

const PackageList = ({
  allServices = [],
  slug = "",
  mainCatName,
}: PackageListProps) => {
  const dispatch = useDispatch();
  const { updateCartQuantity, getPriceIdByServiceId, countByService } =
    useCart();

  const handleOpenAddModalOnly = (
    service: Service,
    numberOfOptions: number,
    name: string,
    isPackage: boolean
  ) => {
    if (
      slug === "immigration" ||
      slug === "emirates-id" ||
      slug === "tas-heel" ||
      slug === "taw-jeeh" ||
      slug === "dubai-health-authority"
    ) {
      if (service?.PackageId) {
        sessionStorage.setItem(
          "packageMainId",
          JSON.stringify(service?.PackageId)
        );
      }
      if (numberOfOptions === 1) {
        sessionStorage.setItem(
          "PriceRecordId",
          JSON.stringify(service.prices[0].PriceRecordId)
        );
      }

      sessionStorage.setItem(
        "serviceid",
        JSON.stringify(service?.Recordid ?? 0)
      );
      dispatch(setNewPackageModelTrue());
    } else {
      handleOpenAddModal(service, numberOfOptions, name, isPackage, false);
    }
  };

  const handleOpenAddModal = (
    service: Service,
    numberOfOptions: number,
    name: string,
    isPackage: boolean,
    isModel: boolean
  ) => {
    if (isPackage !== true) {
      if (isModel !== true) {
        if (name === "add") {
          if (numberOfOptions > 1) {
            sessionStorage.setItem(
              "serviceid",
              JSON.stringify(service?.Recordid ?? 0)
            );
            dispatch(openAddModelData());
          } else {
            updateCartQuantity(
              service.prices[0].PriceRecordId,
              service.Recordid ?? 0,
              "plus"
            );
          }
        } else {
          sessionStorage.setItem(
            "serviceid",
            JSON.stringify(service.Recordid ?? 0)
          );
          dispatch(openAddModelData());
        }
      } else {
        sessionStorage.setItem(
          "serviceid",
          JSON.stringify(service?.Recordid ?? 0)
        );
        dispatch(openUpdateModelData());
      }
    } else {
      sessionStorage.setItem(
        "serviceid",
        JSON.stringify(service.Recordid ?? 0)
      );
      dispatch(openUpdateModelData());
    }
  };

  return (
    allServices &&
    allServices.map((service) => (
      <div
        className="list-card-main pk layout-border d-flex align-items-start align-items-md-center justify-content-between pt-3 p-3"
        key={`service-${service.Recordid}`}
      >
        <div className="col-8">
          <div id={`inside_${service.Recordid}`} />
          <div className=" font-12 ff-semibold text-white d-flex align-items-center gap-2 bg-primary w-fit px-3 py-1 rounded-pill mb-2">
            <div className="d-flex align-items-center ">
              <img
                src="https://goodhand.b-cdn.net/Assets/Upload/gift.svg"
                alt=""
                style={{
                  height: "14px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </div>
            {/* <div>{mainCatName}</div> */}
            <div>Package</div>
          </div>
          <div className="sub-hd1" id={service.Recordid.toString()}>
            <p className="mb-0">{service.serviceName}</p>
          </div>
          <div className="d-flex align-items-center gap-2 py-1">
            <div className="d-flex">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="0.500732"
                  width="12.5"
                  height="12.5"
                  rx="6.25"
                  fill="#4C9636"
                />
                <path
                  d="M6.15695 3.23863C6.1863 3.1483 6.31408 3.1483 6.34343 3.23863L7.08111 5.50897C7.09424 5.54937 7.13188 5.57672 7.17435 5.57672H9.56154C9.65651 5.57672 9.696 5.69825 9.61917 5.75407L7.68789 7.15723C7.65353 7.18219 7.63915 7.22644 7.65228 7.26684L8.38996 9.53718C8.41931 9.62751 8.31593 9.70262 8.23909 9.6468L6.30782 8.24364C6.27346 8.21868 6.22693 8.21868 6.19257 8.24364L4.26129 9.6468C4.18446 9.70262 4.08108 9.62751 4.11042 9.53719L4.84811 7.26684C4.86123 7.22644 4.84685 7.18219 4.81249 7.15723L2.88122 5.75407C2.80438 5.69825 2.84387 5.57672 2.93884 5.57672H5.32603C5.3685 5.57672 5.40614 5.54937 5.41927 5.50897L6.15695 3.23863Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="ff-normal font-12 text-muted">4.6 (3k Reviews)</div>
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap border-dashed pb-2">
            {service.prices.length > 1 ? (
              <p className="d-flex align-items-center gap-1 mb-0 ">
                <span className="in-badge p-0 ff-normal">
                  Start from &nbsp;
                  <span className="ff-currency ff-medium font-16"></span>
                  {Math.min(
                    ...service.prices.map((price) => price.PriceAmount)
                  ).toLocaleString()}
                </span>
              </p>
            ) : (
              service.prices.map((price) => (
                <p
                  className="d-flex align-items-center gap-1 mb-0"
                  key={`price-${service.Recordid}-${price.PriceType}`}
                >
                  <span className="text-black ff-bold font-14 mb-0">
                    {mainCatName === "Packages" && (
                      <>
                        <span className="ff-medium"> Start from </span>
                        <span className="ff-currency ff-medium font-16"></span>
                      </>
                    )}
                    {price.PriceAmount === 0
                      ? `${price.PriceType}`
                      : `${price.PriceAmount.toLocaleString()}`}
                    &nbsp;
                    {price.OldPriceAmount > price.PriceAmount &&
                      price.OldPriceAmount > price.PriceAmount && (
                        <s className="text-secondary ff-medium pe-1">
                          {price.PriceAmount !== 0 && price.PriceCurrency}
                          &nbsp;
                          {Math.min(
                            ...service.prices.map(
                              (price) => price.OldPriceAmount
                            )
                          ).toLocaleString()}
                        </s>
                      )}
                  </span>
                </p>
              ))
            )}
          </div>
          {service.maxSaving >= 1 && (
            <div className="up-to">
              <span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  fill="#07794C"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 7.929L8.472 1.4a.997.997 0 00-.904-.274l-5.04 1.008a.5.5 0 00-.393.393l-1.008 5.04a.998.998 0 00.274.904L7.928 15a.999.999 0 001.414 0L15 9.343a.999.999 0 000-1.414zM5.25 6a.75.75 0 110-1.5.75.75 0 010 1.5z"
                    fill="#07794C"
                  ></path>
                </svg>
              </span>
              <span className="font-12 ff-medium">
                <span className="ms-1">
                  Up to <span className="ff-currency ff-medium font-16"></span>{" "}
                  {service.maxSaving}&nbsp;
                </span>
                Off
              </span>
            </div>
          )}
          <p className="mb-1"></p>
          {service?.outsideDescriptionArray && (
            <div>
              {service?.outsideDescriptionArray?.map((description, index) => (
                <div
                  className="section"
                  key={`description-${service.Recordid}-${index}`}
                >
                  <ul className="sub-text">
                    <li
                      dangerouslySetInnerHTML={{
                        __html: description ?? "",
                      }}
                    ></li>
                  </ul>
                </div>
              ))}
            </div>
          )}

          <a
            className="btn-link ff-semibold font-14 text-primary ms-0 ps-0"
            data-bs-toggle="modal"
            onClick={() =>
              handleOpenAddModal(
                service,
                service.numberOfOptions,
                "ViewDetail",
                service.isPackage,
                service.isModel
              )
            }
            style={{
              cursor: "pointer",
              textDecoration: "none",
              marginLeft: "1.3rem",
            }}
            rel="nofollow"
          >
            View Detail
          </a>
        </div>
        <div>
          <div className="image-container">
            <div>
              <img
                loading="lazy"
                src="https://goodhand.b-cdn.net/Assets/placeholder.png"
                alt={service.imgAlt ?? service.serviceName}
                className="image-bg"
              />
              <div className="packge-count-main w-100">
                <span className="count">{service.totalServiceCount || 5}</span>
                <span className="label">Services </span>
              </div>
            </div>

            {getPriceIdByServiceId(service?.ServiceId) ? (
              <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex align-items-center btn-add position-absolute gap-1 gap-md-2">
                  <button
                    className="bt-mi p-0"
                    onClick={() =>
                      updateCartQuantity(
                        service?.ServiceId,
                        getPriceIdByServiceId(service?.ServiceId),
                        "minus",
                        1
                      )
                    }
                  >
                    -
                  </button>
                  <span className="counter-numbers">
                    {/* (service?.ServiceId === carsummery?.ServiceId) ?? cartsummery.carsummery */}

                    <AnimatedNumber
                      value={countByService(service.ServiceId) || 0}
                    />
                  </span>
                  <button className="bt-plu p-0">+</button>
                </div>
              </div>
            ) : (
              <div
                className="btn-add position-absolute"
                onClick={() =>
                  handleOpenAddModalOnly(
                    service,
                    service.numberOfOptions,
                    "add",
                    service.isPackage
                  )
                }
              >
                Add
              </div>
            )}
          </div>
        </div>
      </div>
    ))
  );
};
export default PackageList;
